export default __webpack_public_path__ + "static/logo_new-4d7244a89c7c2fcc34d26012e3afe1a8.jpg";